import PropTypes from "prop-types";
import React, { Fragment } from "react";
import { Helmet } from "react-helmet";

import { GetAPreliminaryProposal } from "ducks/GetAPreliminaryProposal/index";
export default function GetAPreliminaryProposalPage({
  location: { hash },
  pageContext: { action },
}) {
  return (
    <Fragment>
      <Helmet>
        <title>{"Get A Preliminary Proposal - Savant Power"}</title>
      </Helmet>
      <GetAPreliminaryProposal action={action} hash={hash} />
    </Fragment>
  );
}

GetAPreliminaryProposalPage.propTypes = {
  location: PropTypes.shape({ hash: PropTypes.string }),
  pageContext: PropTypes.shape({ action: PropTypes.string.isRequired }),
};
